import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Trophy, Gift, Crown, Coins } from "lucide-react";
import { api } from "@/lib/api";

function Row({ e, unit }) {
  const medal = e.rank === 1 ? "🥇" : e.rank === 2 ? "🥈" : e.rank === 3 ? "🥉" : null;
  return (
    <motion.div initial={{ opacity: 0, x: -10 }} animate={{ opacity: 1, x: 0 }}
      data-testid={`lb-row-${e.rank}`}
      className={`pe-card rounded-2xl p-4 flex items-center gap-4 ${e.is_me ? "border border-[#D4AF37]/60" : ""}`}>
      <div className="w-8 text-center font-heading text-2xl">{medal || <span className="text-[#A0A0A0]">{e.rank}</span>}</div>
      <div className="w-11 h-11 rounded-full overflow-hidden bg-[#1A1A1A] border border-[#2A2A2A] flex-shrink-0">
        {e.photo && <img src={e.photo} alt="" className="w-full h-full object-cover" />}
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-white font-medium truncate flex items-center gap-2">{e.name} {e.is_me && <span className="text-[10px] text-[#D4AF37]">(you)</span>}</div>
        <div className="text-[11px] text-[#A0A0A0]">{e.count} gift{e.count === 1 ? "" : "s"}</div>
      </div>
      <div className="text-right">
        <div className="font-heading text-xl gold-text flex items-center gap-1"><Coins size={14} /> {e.coins.toLocaleString()}</div>
        <div className="text-[10px] text-[#A0A0A0]">{unit}</div>
      </div>
    </motion.div>
  );
}

function Board({ title, icon: Icon, rows, unit, empty }) {
  return (
    <div>
      <div className="flex items-center gap-2 mb-4"><Icon className="text-[#D4AF37]" size={20} /><h3 className="font-heading text-2xl">{title}</h3></div>
      {rows.length === 0 ? (
        <div className="pe-card rounded-2xl p-8 text-center text-[#A0A0A0] text-sm">{empty}</div>
      ) : (
        <div className="space-y-2">{rows.map((e) => <Row key={e.id} e={e} unit={unit} />)}</div>
      )}
    </div>
  );
}

export default function Leaderboard() {
  const [data, setData] = useState({ top_senders: [], top_earners: [] });
  useEffect(() => { api.get("/gifts/leaderboard").then((r) => setData(r.data)).catch(() => {}); }, []);

  return (
    <div className="p-6 md:p-12 max-w-4xl mx-auto" data-testid="leaderboard-page">
      <div className="overline mb-1">This week in the Empire</div>
      <h2 className="font-heading text-3xl md:text-4xl mb-2 flex items-center gap-3"><Trophy className="text-[#D4AF37]" /> Gift Leaderboard</h2>
      <p className="text-[#A0A0A0] text-sm mb-8 max-w-xl">The Empire's most generous senders and most-adored creators over the last 7 days. Send gifts to climb the ranks.</p>
      <div className="grid md:grid-cols-2 gap-8">
        <Board title="Top Gifters" icon={Gift} rows={data.top_senders} unit="sent"
          empty="No gifts sent yet this week — be the first big spender!" />
        <Board title="Most Adored" icon={Crown} rows={data.top_earners} unit="earned"
          empty="No gifts received yet this week — creators, it's your time to shine!" />
      </div>
    </div>
  );
}
